export default __webpack_public_path__ + "static/media/minePath.125a0755.svg";